module.exports = __webpack_public_path__ + "static/media/info-blue@2x.c574d39f.svg";